module.exports = __webpack_public_path__ + "img/user.fe3ec9f6.svg";